import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const accessToken = useSelector((state) => state.auth?.accessToken || state.auth?.token);
  const localToken = localStorage.getItem("accessToken");

  if (!accessToken && !localToken) {
    window.location.href = process.env.REACT_APP_HOME_URL;
    return null;
  }

  return children;
};

export default ProtectedRoute;
